import { useCallback, useEffect, useState } from 'react'

/**
 * Custom hook to copy text to the clipboard and track copy state.
 * @param resetDelay Time in milliseconds to reset the copied state (default: 2000ms)
 * @returns An object containing the copyToClipboard function and isCopied boolean
 */
export function useCopyToClipboard(resetDelay = 2000) {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (!isCopied) return

    const timeout = setTimeout(() => setIsCopied(false), resetDelay)
    return () => clearTimeout(timeout)
  }, [isCopied, resetDelay])

  const copyToClipboard = useCallback((value: string | (() => string)) => {
    const text = typeof value === 'function' ? value() : value
    void navigator.clipboard.writeText(text).then(() => setIsCopied(true))
  }, [])

  return { copyToClipboard, isCopied }
}
